module.exports = function() {
  return new Worker(__webpack_public_path__ + "11f19cf7791f2c4631ff.worker.js");
};